import { z } from 'zod';

export const formSchema = z.object({
  task: z.string({ required_error: 'Selecione um trabalho' }),
  customTask: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>;